import React from 'react';
import * as S from './styles';
import Events from '../../Events';
import Aguas from '../../../front-novo/icons/Aguas.svg';
import Pequi from '../../../front-novo/icons/Pequi.svg';
import Tronco from '../../../front-novo/icons/Tronco.svg';
import Sol from '../../../front-novo/icons/Sol.svg';
import Gaviao from '../../../front-novo/icons/Gaviao.svg';
import bordercardimg from '../../../front-novo/home/bordercardimg.png';
import Barbatimao from '../../../front-novo/icons/Barbatimao.svg';
import Cacto from '../../../front-novo/icons/Cacto.svg';
import Guara from '../../../front-novo/icons/Guara.svg';
import { useHistory } from 'react-router-dom'; // Importando useHistory para a navegação

function Home4() {
  const history = useHistory(); // Criando uma função de navegação

  const handleNavigation = () => {
    history.push('/contato'); // Redireciona para a página /services
  };
  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <S.title>
            <hr></hr>
          </S.title>
          <S.TextHorizontal>
            <div>
              <img src={Sol} />
              <h3>GRUPO DE ESTUDOS </h3>
              <hr />
              <p>
                Encontros semanais ou quinzenais com o objetivo de fomentar
                estudo psicanalítico por meio de temas ofertados semestralmente.
                Para se matricular, entre em contato diretamente com o mentor do
                grupo pelo qual você tiver interesse.
              </p>
              <button onClick={handleNavigation}>Conheça nossos grupos</button>
            </div>
            <div>
              <img src={Gaviao} />
              <h3>GRUPOS DE SUPERVISÃO</h3>
              <hr />
              <p>
                Encontros semanais ou quinzenais com o objetivo de fomentar
                estudo psicanalítico por meio de temas ofertados semestralmente.
                Para se matricular, entre em contato diretamente com o mentor do
                grupo pelo qual você tiver interesse.
              </p>
              <button onClick={handleNavigation}>Fale com a gente</button>
            </div>
            <div>
              <img src={Pequi} />
              <h3>CLUBES DE LEITURA</h3>
              <hr />
              <p>
                Encontros semanais ou quinzenais com o objetivo de fomentar
                estudo psicanalítico por meio de temas ofertados semestralmente.
                Para se matricular, entre em contato diretamente com o mentor do
                grupo pelo qual você tiver interesse.
              </p>
              <button onClick={handleNavigation}>Faça parte também</button>
            </div>
            <div>
              <img src={Aguas} />
              <h3>SEMINÁRIOS INTERNOS</h3>
              <hr />
              <p>
                Encontros semanais ou quinzenais com o objetivo de fomentar
                estudo psicanalítico por meio de temas ofertados semestralmente.
                Para se matricular, entre em contato diretamente com o mentor do
                grupo pelo qual você tiver interesse.
              </p>
              <button onClick={handleNavigation}>Confira nossa agenda</button>
            </div>
            <div>
              <img src={Tronco} />
              <h3>SEMINÁRIOS EXTERNOS</h3>
              <hr />
              <p>
                Encontros semanais ou quinzenais com o objetivo de fomentar
                estudo psicanalítico por meio de temas ofertados semestralmente.
                Para se matricular, entre em contato diretamente com o mentor do
                grupo pelo qual você tiver interesse.
              </p>
              <button onClick={handleNavigation}>Confira nossa agenda</button>
            </div>
            <div>
              <img src={Guara} />
              <h3>ESPECIALIZAÇÃO EM PSICANÁLISE</h3>
              <hr />
              <p>
                Encontros semanais ou quinzenais com o objetivo de fomentar
                estudo psicanalítico por meio de temas ofertados semestralmente.
                Para se matricular, entre em contato diretamente com o mentor do
                grupo pelo qual você tiver interesse.
              </p>
              <button onClick={handleNavigation}>Fale com a gente</button>
            </div>
          </S.TextHorizontal>
        </S.TextDiv>
      </S.Section>
    </S.Main>
  );
}

export default Home4;
